<template>
  <el-form-item class="uploadTypeRadio mb-0" :label="label" :prop="prop" :inline-message="true">
    <el-radio-group
      v-model="optionValue"
      :disabled="disabled"
      class="pl-0.5 w-full flex flex-wrap sm:flex-nowrap md:flex-wrap items-stretch justify-start gap-5"
      ><RegisterCheckButton
        v-for="option in options"
        :key="option.value"
        :currValue="optionValue"
        :value="option.value"
        class="w-full sm:w-auto sm:flex-1 md:flex-none md:min-w-42"
        ><div class="flex items-center justify-center gap-1">
          <div>{{ $t(option.label) }}</div>
          <el-tooltip v-if="option.infoText && option.infoText.length > 0" placement="top">
            <template #content>
              <div class="max-h-41 overflow-y-auto whitespace-pre-line">
                {{ $t(option.infoText) }}
              </div></template
            >
            <svg-icon iconName="info-circle-icon" className="tooltip-icon" />
          </el-tooltip>
        </div> </RegisterCheckButton></el-radio-group
  ></el-form-item>
</template>

<script>
import RegisterCheckButton from '@/components/register/RegisterCheckButton.vue';

export default {
  name: 'UploadTypeRadio',
  props: {
    // Array<{label: "", value: "", infoText: ""}>
    options: { type: Array, required: true },
    onChange: { type: Function, required: true },
    value: { type: [String, Number, null], required: true },
    // el-form-item prop
    prop: { type: String, required: true },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return { optionValue: null };
  },
  watch: {
    value(value) {
      this.optionValue = value;
    },
    optionValue(optionValue) {
      this.onChange(optionValue);
    }
  },
  mounted() {
    this.optionValue = this.value;
  },
  components: { RegisterCheckButton }
};
</script>

<style lang="scss" scoped>
.uploadTypeRadio .el-radio ::v-deep {
  margin-right: 0;
  .el-radio__label {
    padding: 0;
  }
  .el-radio__input {
    display: none;

    &.is-checked + .el-radio__label {
      color: inherit;
    }
  }
}
</style>
